export default __webpack_public_path__ + "solutionIcon3.3243005.png";